module.exports = __webpack_public_path__ + "static/media/tracking.fcd57758.svg";